import { Component, OnInit, OnDestroy, EventEmitter, AfterViewInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DCInput } from './includes/dynamic_components/dynamic.service';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { DialogService } from './includes/dynamic_components/dialog/dialog.service';
import { throwError } from 'rxjs';

@Component({
    selector: 'upload-form',
    templateUrl: `upload.form.component.html`,
    styleUrls: ["upload.form.component.css"]
})

export class UploadFormComponent implements OnInit, OnDestroy, AfterViewInit, DCInput {
    readonly URL_LIST_STORAGE = "loaded_url_list";
    title="Загрузка плейлиста";
    /**
     * Ссылка на плейлист.
     */
    url:string = "";
    /**
     * Список ссылок на плейлист.
     */
    url_list:string[] = [];
    /**
     * Флаг скрывающий элемент со списком URL
     */
    urlListHidden:boolean = true;
    /**
     * Флаг запрещающий скрывать список URL 
     * @example Если ссылка удаляется, то не надо скрывать список.
     */
    private hideUrlList:boolean = true;
    /**
     * Элемент input ввода url
     */
    @ViewChild("inputElement", {static: true}) inputElement:ElementRef<HTMLInputElement> = null;
    /**
     * HTML елемент списка ссылок 
     */
    @ViewChild("urlList", {static: true}) urlList:ElementRef<HTMLDivElement> = null;
    /**
     * Отключает кнопку загрузки URL
     */
    disableUrl:boolean = false;
    /**
     * Передаёт загруженный плейлист.
     */
    loadedPlaylist:EventEmitter<string> = new EventEmitter();
    destroyEmitter = new EventEmitter();
    constructor(private _http:HttpClient, private _dialog:DialogService ) {
        let  url_list = JSON.parse(localStorage.getItem(this.URL_LIST_STORAGE));
        if(url_list instanceof Array && url_list.length){
            this.url_list = url_list;
        }
     }

    ngOnInit() { }
    ngAfterViewInit(){
        // Перемещаем список плейлистов под body, чтобы относительно него позиционировать узел.
        document.body.appendChild(this.urlList?.nativeElement);
        // Если окно меняется, то изменяем элемента списка url
        window.addEventListener("resize",()=>{ this.window_resize(); });
    }
    ngOnDestroy() { 
        // Удаляем обработчик изменения окна
        window.removeEventListener("resize",()=>{ this.window_resize(); });
        // Удаляем узел с ссылками из body
        this.urlList?.nativeElement?.remove();
        this.destroyEmitter.complete();
        this.loadedPlaylist.complete();
    }
    /**
     * Закрывает окно
     */
    close(){
        this.destroyEmitter.emit(null);
    }
    /**
     * Отображает список ранее вставленных URL плейлистов при фокусировки поля ввода.
     */
    url_focus(){
        !this.hideUrlList ? (this.hideUrlList = true) : null;
        const url_list = this.urlList?.nativeElement;
        if(url_list && this.url_list?.length > 0) {
            this.url_list_set_position();
            this.urlListHidden = false;
        }
    }
    /**
     * Скрывает список плейлистов, если поле ввода потеряло фокусировку.
     */
    url_blur(e:FocusEvent){
        if(this.hideUrlList) {
            this.urlListHidden = true;
        } else {
            this.hideUrlList = true;
        }
    }
    /**
     * Обработчик изменения окна браузера
     */
    private window_resize() {
        setTimeout(() => {
            const url_list = this.urlList?.nativeElement;
            if(url_list && url_list.style.display !== "none") {
                this.url_list_set_position();
            }
        }, 500);
    }
    /**
     * Устанавливает размер и позицию элемента со списком url плейлисов.
     */
    private url_list_set_position(){
        const url_list = this.urlList?.nativeElement;
        const coord = this.inputElement.nativeElement.getBoundingClientRect();
        url_list.style.top = coord.bottom + 5 + "px";
        url_list.style.left = coord.left + "px";
        // Задаем максимальную ширину, чтобы список не выходил за пределы окна и были доступны кнопки удаления 
        const maxWidth = Math.max(document.documentElement.clientWidth - coord.left - 13, 150) + "px",
              maxHeight = Math.max(document.documentElement.clientHeight - coord.top - coord.height - 10, 100) + "px";
        url_list.getElementsByTagName("ul")[0].style.maxWidth = maxWidth;
        url_list.getElementsByTagName("ul")[0].style.maxHeight = maxHeight;
    }
    /**
     * Удаляет ссылку из списка и записывает обновленный список в LocalStorage
     * @param url Ссылка на плейлист.
     */
    url_remove(url:string){
        // Запрещаем скрывать список ссылок.
        this.hideUrlList = false;
        const index = this.url_list.indexOf(url);
        if(index > -1) {
            // this.url_list.unshift(url); // Для тестирования
            this.url_list.splice(index,1);
            localStorage.setItem(this.URL_LIST_STORAGE, JSON.stringify(this.url_list));
        }
        // Если список пуст, то скываем элемент списка, чтобы не отображалась стрелочка оставшаяся от этого элемента
        if(this.url_list?.length < 1) this.urlListHidden = true;
        // setTimeout(()=>{
        //     this.inputElement.nativeElement.focus();
        // },100);
    }
    /**
     * Загрузка плейлиста по ссылке
     */
    load_url(){
        this.url = this.url.trim();
        this.disableUrl = true;
        // Спинер AJAX загрузки данных
        let ajaxLoader: HTMLDivElement| {className: ""} = <HTMLDivElement>document.getElementById("ajaxActivity");
        ajaxLoader = ajaxLoader ? ajaxLoader : {className: ""};
        ajaxLoader.className = "show";
        this._http.get(this.url, { responseType: "text"}).pipe(
            map((response:string)=>{
                ajaxLoader.className = ""
                return response;
            }),
            catchError((error:string)=>{
                ajaxLoader.className = ""
                this._dialog.alert("К сожалению загрузить плейлист, не удалось!");
                this.disableUrl = false;
                return throwError(error);
            })
        ).subscribe((response:string)=>{
            if(this.url_list.indexOf(this.url) === -1) {
                this.url_list.unshift(this.url);
                this.url_list = this.url_list.slice(0,50);
                localStorage.setItem(this.URL_LIST_STORAGE, JSON.stringify(this.url_list));
            }
            this.loadedPlaylist.emit(response);
            this.close();
        });
    }

  /**
   * Загрузка файла плейлиста
   * @param e 
   */
  load_file(e:InputEvent){
    e.preventDefault();
    const input = <HTMLInputElement>e.target,
          loader = document.getElementById("ajaxActivity");
    loader.classList.add("show");
    if(input.files && input.files.length){
      const file = input.files[0],
            reader = new FileReader();
      reader.addEventListener("load",(e)=>{
        this.loadedPlaylist.emit(reader.result.toString());
        this.close();
      });
      reader.addEventListener("error", ()=>{
        this._dialog.alert("К сожалению прочитать файл не удалось.");
      });
      reader.addEventListener("loadend", (e)=>{
        loader.classList.remove("show");
      });
      reader.readAsText(file);
    } else {
      this._dialog.alert("Не удалось определить файл!");
      loader.classList.remove("show");
    }
    input.value = ""; // Необходимо, чтобы срабатывало событие input, когда выбирается один и тотже файл.
  }

}